import { ROUTES } from "../../../../routes";
import type { CmsNavState } from "../types";
import type { BpaRow } from "./bpaRows";

export function bpaRowLink(input: {
  editionId: string;
  row: BpaRow;
  editionName: string | null;
  templateType: string | null;
}): { to: string; state: CmsNavState } {
  const { editionId, row, editionName, templateType } = input;

  const state: CmsNavState = {
    bpaName: row.name,
    rankingEntityName: row.rankingEntityName,
    ...(editionName ? { editionName } : {}),
    ...(templateType ? { templateType } : {}),
  };

  return {
    to: ROUTES.research.cmsBpa(editionId, row.id),
    state,
  };
}
